import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    max-width: 1240px;
    margin: 0 auto;
    padding: 0 2rem;

    position: relative;
    z-index:9;
`;